/**
 * Hero collection nav facets: accordion, mobile dropdown positioning (fixed layer).
 *
 * Shopify often returns empty collection.filters for parent URLs like /collections/parent
 * while child URLs /collections/parent/child have filters. Liquid cannot read another
 * collection's filters off-page, so we hydrate the hero form from the first child link.
 */
(function () {
  const MQ = window.matchMedia("(max-width: 989px)");

  const COLLECTIONS_MARKER = "/collections/";

  function parseParentOnlyCollectionPath(pathname) {
    const raw = pathname.replace(/\/$/, "") || "/";
    const i = raw.indexOf(COLLECTIONS_MARKER);
    if (i === -1) return null;
    const after = raw.slice(i + COLLECTIONS_MARKER.length);
    const segments = after.split("/").filter(Boolean);
    if (segments.length !== 1) return null;
    let parentHandle;
    try {
      parentHandle = decodeURIComponent(segments[0]);
    } catch {
      parentHandle = segments[0];
    }
    return { raw, parentHandle };
  }

  function pathnameSegmentsAfterCollections(pathname) {
    const p = pathname.replace(/\/$/, "") || "/";
    const i = p.indexOf(COLLECTIONS_MARKER);
    if (i === -1) return null;
    return p
      .slice(i + COLLECTIONS_MARKER.length)
      .split("/")
      .filter(Boolean)
      .map((s) => {
        try {
          return decodeURIComponent(s);
        } catch {
          return s;
        }
      });
  }

  function findFirstNestedChildCollectionHref(parentHandle, raw) {
    const links = document.querySelectorAll("main a[href]");
    for (const a of links) {
      const href = a.getAttribute("href");
      if (!href || href.startsWith("#")) continue;
      let path;
      try {
        path = new URL(href, window.location.origin).pathname.replace(/\/$/, "");
      } catch {
        continue;
      }
      if (path === raw) continue;
      const segs = pathnameSegmentsAfterCollections(path);
      if (!segs || segs.length < 2) continue;
      if (segs[0] !== parentHandle) continue;
      return path;
    }
    return null;
  }

  function maybeHydrateHeroFiltersFromNestedChild() {
    const parsed = parseParentOnlyCollectionPath(window.location.pathname);
    if (!parsed) return;
    const { raw, parentHandle } = parsed;

    const navForm = document.getElementById("FacetFiltersNavForm");
    const drawerForm = document.getElementById("FacetFiltersForm");
    if (!navForm && !drawerForm) return;

    const list = navForm?.querySelector(".nav-filters__list");
    const needsNavHydrate =
      navForm &&
      list &&
      list.querySelectorAll(".nav-filters__item:not(.nav-filters__item--clear)").length === 0;
    const needsDrawerHydrate =
      drawerForm && drawerForm.querySelectorAll(".js-filter").length === 0;

    if (!needsNavHydrate && !needsDrawerHydrate) return;

    const childPath = findFirstNestedChildCollectionHref(parentHandle, raw);
    if (!childPath) return;

    const sectionId = document.getElementById("product-grid")?.dataset?.id;
    if (!sectionId) return;

    const fetchUrl = `${childPath}?section_id=${encodeURIComponent(sectionId)}`;
    fetch(fetchUrl)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");

        const rewrite = (inner) =>
          childPath !== raw ? inner.split(childPath).join(raw) : inner;

        if (needsNavHydrate && navForm) {
          const srcNav = doc.getElementById("FacetFiltersNavForm");
          if (srcNav) {
            navForm.innerHTML = rewrite(srcNav.innerHTML);
          }
        }

        if (needsDrawerHydrate && drawerForm) {
          const srcDrawer = doc.getElementById("FacetFiltersForm");
          if (srcDrawer) {
            drawerForm.innerHTML = rewrite(srcDrawer.innerHTML);
          }
        }

        const FacetCtor = window.customElements?.get("facet-filters-form");
        if (FacetCtor && typeof FacetCtor.handleHeroFilters === "function") {
          FacetCtor.handleHeroFilters();
        }
      })
      .catch(() => {});
  }

  function runHeroHydrate() {
    maybeHydrateHeroFiltersFromNestedChild();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runHeroHydrate);
  } else {
    runHeroHydrate();
  }

  function closeSiblingDetails(openDetail) {
    const toolbar = openDetail.closest(".nav-filters--toolbar");
    if (!toolbar) return;
    toolbar.querySelectorAll("details.nav-filters__details[open]").forEach((d) => {
      if (d !== openDetail) d.removeAttribute("open");
    });
  }

  function clearMobilePanelStyles(panel) {
    if (!panel) return;
    panel.classList.remove("nav-filters__dropdown--fixed");
    ["position", "left", "right", "top", "width", "maxWidth", "maxHeight", "zIndex"].forEach(
      (prop) => {
        panel.style.removeProperty(prop);
      }
    );
  }

  function positionMobileDropdown(detail) {
    const panel = detail.querySelector(".nav-filters__dropdown");
    const summary = detail.querySelector("summary");
    if (!panel || !summary) return;

    if (!MQ.matches) {
      clearMobilePanelStyles(panel);
      return;
    }

    const rect = summary.getBoundingClientRect();
    const gap = 8;
    const inset = 12;
    const top = rect.bottom + gap;
    const maxH = Math.max(120, window.innerHeight - top - inset);

    panel.classList.add("nav-filters__dropdown--fixed");
    panel.style.position = "fixed";
    panel.style.left = `${inset}px`;
    panel.style.right = `${inset}px`;
    panel.style.width = "auto";
    panel.style.maxWidth = "none";
    panel.style.top = `${top}px`;
    panel.style.maxHeight = `${maxH}px`;
    panel.style.zIndex = "200";
  }

  document.addEventListener(
    "toggle",
    function (e) {
      const t = e.target;
      if (!t || t.tagName !== "DETAILS") return;
      if (!t.classList.contains("nav-filters__details")) return;

      if (t.open) {
        closeSiblingDetails(t);
        requestAnimationFrame(() => positionMobileDropdown(t));
      } else {
        clearMobilePanelStyles(t.querySelector(".nav-filters__dropdown"));
      }
    },
    true
  );

  window.addEventListener("resize", function () {
    document.querySelectorAll("details.nav-filters__details[open]").forEach((d) => {
      positionMobileDropdown(d);
    });
  });

  window.addEventListener(
    "scroll",
    function () {
      if (!MQ.matches) return;
      document.querySelectorAll("details.nav-filters__details[open]").forEach((d) => {
        positionMobileDropdown(d);
      });
    },
    true
  );
})();
